export default __webpack_public_path__ + "static/media/Bracers of Ardent Fire.8ad6d43b.jpg";